import { render, staticRenderFns } from "./CmgPickupDeliveryToggle.vue?vue&type=template&id=754eb46c&scoped=true&lang=pug"
import script from "./cmg-pickup-delivery-toggle.ts?vue&type=script&lang=ts&external"
export * from "./cmg-pickup-delivery-toggle.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPickupDeliveryToggle.vue?vue&type=style&index=0&id=754eb46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754eb46c",
  null
  
)

export default component.exports